import React, { Component, useState, useRef } from "react";
import {
  makeStyles,
  withStyles,
  useTheme,
  styled,
} from "@material-ui/core/styles";
import Save from "../../../../Assets/img/svg/save.svg";
import Cancel from "../../../../Assets/img/svg/cancel.svg";
import image from "../../../../Assets/img/svg/Image.svg";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import { DragIndicator, ThumbUpAltOutlined } from "@material-ui/icons";
import {
  TextField,
  InputBase,
  InputAdornment,
  IconButton,
  Checkbox,
} from "@material-ui/core";
import AttachFileIcon from "@material-ui/icons/AttachFile";
import Autocomplete from "react-autocomplete";
import { useNavigate } from "react-router-dom";
import withRouter from "../../../custom/withRouter";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import styles from "../../../../Assets/jss/customStyle";
import List from "@material-ui/core/List";
import NavigateNextIcon from "@material-ui/icons/NavigateNext";
import Typography from "@material-ui/core/Typography";
import Divider from "@material-ui/core/Divider";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import $ from "jquery";
import moment from "moment";
import Delete from "../../../../Assets/img/svg/delete.svg";
import axios from "axios";
import API from "../../../../helpers/endpointService";
import del from "../../../../Assets/img/svg/Del.svg";
import { inspectionSystem } from "../../../Constants";
import { CssTextField } from "../../../custom/textField";
import {
  putDetailedSummaryDesc,
  putShortSummaryDesc,
  PutShipSummaryInfo,
} from "../../../../actions/InspectionActions";
import { htmlDecode, htmlEncode, ReportDesc } from "../EncodeDecode.js";
import { warningAlert, successAlert } from "../../../custom/alert";
import { successToast, errorToast } from "../../../../actions/CommonFunction";
import "./AddEditDESC.css";

const INSPECTION_SCORE_MIN = 0;
const INSPECTION_SCORE_MAX = 100;
const INSPECTION_SCORE_FIELDS = ["TotalGrade", "Condition", "Management"];

const reorder = (list, startIndex, endIndex) => {
  const result = Array.from(list);
  const [removed] = result.splice(startIndex, 1);
  result.splice(endIndex, 0, removed);
  return result;
};

const useStyles = makeStyles((theme) => ({
  chips: {
    display: "flex",
    flexWrap: "wrap",
  },
  chip: {
    margin: 2,
  },
  error: {
    color: "#f44336",
  },
  helperText: {
    "& p": {
      marginLeft: "0px !important",
    },
  },
  button: {
    background: "#FFFFFF",
    border: "none",
    boxSizing: "border-box",
    borderRadius: "7px",
  },
}));

const BootstrapError = withStyles((theme) => ({
  root: {
    "label + &": {
      marginTop: theme.spacing(3),
    },
  },
  input: {
    borderRadius: 0,
    position: "relative",
    backgroundColor: theme.palette.background.paper,
    border: "1px solid #f44336",
    fontSize: 16,
    padding: "10px 26px 10px 12px",
    transition: theme.transitions.create(["border-color", "box-shadow"]),
  },
}))(InputBase);

const BootstrapInput = withStyles((theme) => ({
  root: {
    "label + &": {
      marginTop: theme.spacing(3),
    },
  },
  input: {
    borderRadius: 0,
    position: "relative",
    backgroundColor: theme.palette.background.paper,
    border: "1px solid #ced4da",
    fontSize: 16,
    padding: "10px 26px 10px 12px",
    transition: theme.transitions.create(["border-color", "box-shadow"]),
  },
}))(InputBase);

const names = ["Oliver Hansen", "Van Henry", "April Tucker", "Ralph Hubbard"];

const CheckboxWithBlackCheck = withStyles({
  root: {
    "& .MuiSvgIcon-root": {
      fill: "#FFFFFF",
      width: 20,
      height: 20,
      border: "1px solid #000000",
      "&:hover": {
        backgroundColor: "#FFFFFF",
      },
    },
    "&$checked": {
      "& .MuiIconButton-label": {
        position: "relative",
        zIndex: 0,
        backgroundColor: "#FFFFFF",
      },
      "& .MuiIconButton-label:after": {
        content: '""',
        height: 10,
        width: 10,
        position: "absolute",
        backgroundColor: "#000000",
        zIndex: -1,
      },
    },
  },
  checked: {},
})(Checkbox);

function getStyles(name, personName, theme) {
  return {
    fontWeight:
      personName.indexOf(name) === -1
        ? theme.typography.fontWeightRegular
        : theme.typography.fontWeightMedium,
  };
}

class AddEditDESC extends Component {
  constructor(props) {
    super(props);
    this.inputFile = React.createRef();
    this.state = {
      isMobile: false,
      putData: false,
      isError1: false,
      isError2: false,
      isError3: false,
      cancel: false,
      DateError: false,
      addData: {
        Id: 0,
        ShipId: 0,
        SectionId: 0,
        InspectionId: 0,
        TotalGrade: "",
        Condition: "",
        Management: "",
        CreatedBy: "",
        Modifiedby: "",
      },
      addShortDescription: {
        Id: 0,
        ShipId: 0,
        SectionId: 0,
        Description: "",
        IsDeleted: true,
        InspectionId: 0,
        CreatedBy: "",
        ModifiedBy: "",
        ReportDescription: "",
      },
      addDetailedDescription: {
        Id: 0,
        ShipId: 0,
        InspectionId: 0,
        SectionId: 0,
        Description: "",
        IsDeleted: true,
        CreatedBy: "",
        ModifiedBy: "",
        ReportDescription: "",
      },
      CancelSummary: "",
      CancelSummary1: "",
      initialLoad: true,
    };
    this.debouncedSummernoteChange = this.debounce(
      this.handleSummernoteChange,
      500 // debounce delay (ms)
    );
  }
  debounce(func, wait) {
    let timeout;
    return (...args) => {
      clearTimeout(timeout);
      timeout = setTimeout(() => func.apply(this, args), wait);
    };
  }

  componentDidMount() {
    let Shipid = parseInt(localStorage.getItem("DashId"));
    let inspectioid = parseInt(localStorage.getItem("InspectionId"));
    this.state.addData.ShipId = Shipid;
    this.state.addData.SectionId = inspectionSystem.InspectionSummary;
    this.state.addData.InspectionId = inspectioid;
    this.state.addShortDescription.ShipId = Shipid;
    this.state.addDetailedDescription.ShipId = Shipid;
    this.state.addShortDescription.InspectionId = inspectioid;
    this.state.addDetailedDescription.InspectionId = inspectioid;
    this.state.addShortDescription.SectionId = inspectionSystem.SummaryShort;
    this.state.addDetailedDescription.SectionId =
      inspectionSystem.SummaryDetailed;
    this.state.addShortDescription.ModifiedBy =
      localStorage.getItem("UserRoles");
    this.state.addDetailedDescription.ModifiedBy =
      localStorage.getItem("UserRoles");
    this.setState({});
    this.props.dispatch({ type: "RICHTEXT", data: true });
    this.props.dispatch({ type: "RICHTEXT1", data: true });
    if (Shipid !== 0 && inspectioid !== 0) {
      this.getShipSummaryInfo(Shipid, inspectioid);
      this.getShortSummaryDesc(Shipid, inspectioid);
      // this.getDetailedSummaryDesc(Shipid, inspectioid);
    }
    window.addEventListener("resize", this.resize.bind(this));
    this.resize();
    this.interval = setInterval(() => {
      this.resize1();
    }, 10);
    window["summernote_addEditDesc"]();
    window["summernote_addEditINS"](2000);
    window.addEventListener(
      "summernote1Change",
      this.debouncedSummernoteChange
    );
  }
  componentWillUnmount() {
    clearInterval(this.interval);
    this.props.dispatch({ type: "RICHTEXT", data: false });
    this.props.dispatch({ type: "RICHTEXT1", data: false });
    window.removeEventListener("resize", this.resize.bind(this));
    $("#ISUM1 .MuiListItemText-primary").addClass("spanTopBar");
    $("#InspectionSummary1 .MuiListItemText-primary").removeClass("fw-bolder");
    $("#InspectionSummary").addClass("d-none");
    $("#InspectionSummary").removeClass("d-block");
    $("#INSL").removeClass("active-color");
    $("#INST").removeClass("fw-bolder");
    window.removeEventListener(
      "summernote1Change",
      this.debouncedSummernoteChange
    );
  }

  handleSummernoteChange = (e) => {
    if (this.state.initialLoad) {
      return;
    }
    let ShortSummerResult = window["getsummernote_code1"]();
    if (this.state.addShortDescription.Id === 0) {
      this.state.addShortDescription.CreatedBy =
        localStorage.getItem("UserRoles");
      this.state.addShortDescription.ModifiedBy = "";
      this.state.addShortDescription.Description =
        htmlEncode(ShortSummerResult);
      let ReportShortSummerResult = ReportDesc(ShortSummerResult);
      this.state.addShortDescription.ReportDescription = htmlEncode(
        ReportShortSummerResult
      );
      this.setState({});
      this.addShortSummaryDesc(this.state.addShortDescription);
      // this.setState({ cancel: false });
      // this.props.dispatch({ type: "CANCEL", data: false });
    } else {
      this.state.addShortDescription.CreatedBy = "";
      this.state.addShortDescription.ModifiedBy =
        localStorage.getItem("UserRoles");
      this.state.addShortDescription.Description =
        htmlEncode(ShortSummerResult);
      let ReportShortSummerResult = ReportDesc(ShortSummerResult);
      this.state.addShortDescription.ReportDescription = htmlEncode(
        ReportShortSummerResult
      );
      this.setState({});
      this.props.dispatch(
        putShortSummaryDesc(
          this.state.addShortDescription,
          this.state.addShortDescription.Id
        )
      );

      // let SummeryResult1 = window["getsummernote_code1"]();
      // this.state.CancelSummary = SummeryResult1;
      // this.props.dispatch({ type: "RICHTEXT_CANCEL1", data: SummeryResult1 });
      // this.props.dispatch({ type: "CANCEL", data: false });
    }
  };
  sidebar = () => {
    if (this.state.cancel === true) {
      window.$("#cancelpopup1").modal("show");
    } else {
      this.props.navigate("/sidebar");
    }
  };
  SideBarCancel = () => {
    this.props.dispatch({ type: "CANCEL", data: false });
    window.$("#cancelpopup1").modal("hide");
    this.props.navigate("/sidebar");
  };
  resize = () => {
    if (window.innerWidth < 850) {
      this.setState({
        isMobile: true,
      });
    } else {
      this.setState({
        isMobile: false,
      });
    }
  };

  resize1 = () => {
    $("#ISUM1 .MuiListItemText-primary").addClass("spanTopBar");
    $("#InspectionSummary1 .MuiListItemText-primary").addClass("fw-bolder");
    $("#InspectionSummary").removeClass("d-none");
    $("#InspectionSummary").addClass("d-block");
    $("#INSL").addClass("active-color");
    $("#INST").addClass("fw-bolder");
  };
  AddCancel1 = () => {
    let SummeryResult = window["getsummernote_code"]();
    let SummeryResult1 = window["getsummernote_code1"]();
    if (
      this.state.cancel == true ||
      (this.state.CancelSummary != SummeryResult &&
        SummeryResult != "<p><br></p>") ||
      (this.state.CancelSummary1 != SummeryResult1 &&
        SummeryResult1 != "<p><br></p>")
    ) {
      window.$("#cancelpopup").modal("show");
    } else {
      this.props.dispatch({ type: "CANCEL", data: false });
      this.props.dispatch({ type: "RICHTEXT", data: false });
      this.props.dispatch({ type: "RICHTEXT1", data: false });
      this.props.navigate(`/shiplist`);
    }
  };
  AddCancel = () => {
    this.props.dispatch({ type: "CANCEL", data: false });
    this.props.dispatch({ type: "RICHTEXT", data: false });
    this.props.dispatch({ type: "RICHTEXT1", data: false });
    window.$("#cancelpopup").modal("hide");
    this.props.navigate("/shiplist");
  };
  handleInputChange = (e, node) => {
    if (INSPECTION_SCORE_FIELDS.includes(node)) {
      this.handleScoreInputChange(e, node);
      return;
    }

    this.props.dispatch({ type: "CANCEL", data: true });
    this.state.cancel = true;
    this.state.addData[node] = e.target.value;
    this.setState({});
  };

  isValidScoreValue = (value) => {
    if (value === "" || value === null || value === undefined) {
      return false;
    }

    const num = parseInt(value, 10);
    return (
      !Number.isNaN(num) &&
      num >= INSPECTION_SCORE_MIN &&
      num <= INSPECTION_SCORE_MAX
    );
  };

  getScoreErrorMessage = (field) => {
    const value = this.state.addData[field];
    if (value === "" || value === null || value === undefined) {
      return "Score is required";
    }

    const num = parseInt(value, 10);
    if (
      Number.isNaN(num) ||
      num < INSPECTION_SCORE_MIN ||
      num > INSPECTION_SCORE_MAX
    ) {
      return `Enter a score between ${INSPECTION_SCORE_MIN} and ${INSPECTION_SCORE_MAX}`;
    }

    return "";
  };

  updateScoreFieldError = (field) => {
    const isValid = this.isValidScoreValue(this.state.addData[field]);
    if (field === "TotalGrade") {
      this.state.isError1 = !isValid;
    } else if (field === "Condition") {
      this.state.isError2 = !isValid;
    } else if (field === "Management") {
      this.state.isError3 = !isValid;
    }
  };

  syncScoreFieldErrors = () => {
    this.updateScoreFieldError("TotalGrade");
    this.updateScoreFieldError("Condition");
    this.updateScoreFieldError("Management");
  };

  handleScoreInputChange = (e, node) => {
    this.props.dispatch({ type: "CANCEL", data: true });
    this.state.cancel = true;

    const raw = e.target.value;
    if (raw === "") {
      this.state.addData[node] = "";
      this.updateScoreFieldError(node);
      this.setState({});
      return;
    }

    if (!/^\d+$/.test(raw)) {
      return;
    }

    const num = parseInt(raw, 10);
    if (num > INSPECTION_SCORE_MAX) {
      return;
    }

    this.state.addData[node] = String(num);
    this.updateScoreFieldError(node);
    this.setState({});
  };

  renderScoreFieldGroup = (field, label, isError) => {
    const { classes } = this.props;
    const { isMobile } = this.state;

    const labelNode = (
      <label className={isMobile ? "d-flex m-0 desc-score-label" : "desc-score-label"}>
        {label}&nbsp;:
        {isMobile ? (
          <div className={`${classes.helperText}`}>
            <div className="MuiFormHelperText-contained">*</div>
          </div>
        ) : (
          <span className="desc-score-required">*</span>
        )}
      </label>
    );

    if (isMobile) {
      return (
        <div
          key={field}
          className="col-12 desc-score-field-mobile border-left border-right border-bottom"
        >
          {labelNode}
          <div className="desc-score-input-wrap">{this.renderScoreField(field, isError)}</div>
        </div>
      );
    }

    return (
      <div key={field} className="col-12 col-md-4 desc-score-field-group">
        {labelNode}
        <div className="desc-score-input-wrap">{this.renderScoreField(field, isError)}</div>
      </div>
    );
  };

  renderScoreField = (field, isError) => {
    const { classes } = this.props;

    return (
      <TextField
        variant="outlined"
        size="small"
        fullWidth
        error={isError}
        value={
          this.state.addData[field] === 0 || this.state.addData[field]
            ? this.state.addData[field]
            : ""
        }
        placeholder={`${INSPECTION_SCORE_MIN}-${INSPECTION_SCORE_MAX}`}
        helperText={isError ? this.getScoreErrorMessage(field) : ""}
        onChange={(e) => {
          this.handleScoreInputChange(e, field);
        }}
        InputProps={{
          className: `border-radius ${classes.inputfieldAlign}`,
          style: { fontSize: 12 },
          inputProps: {
            inputMode: "numeric",
            maxLength: 3,
          },
        }}
        FormHelperTextProps={{
          classes: { root: classes.helperText1 },
        }}
      />
    );
  };

  getShipSummaryInfo = (id, inspection) => {
    const { dispatch } = this.props;
    let apiUrl = `${API.Get_Inspection}?ShipId=${id}&InspectionId=${inspection}&SectionId=${inspectionSystem.InspectionSummary}`;
    dispatch({ type: "SHOW_LOADER", data: true });
    axios
      .get(apiUrl)
      .then((response) => {
        if (response?.status === 200) {
          if (response?.data.Id !== 0) {
            this.state.addData = response?.data;
            INSPECTION_SCORE_FIELDS.forEach((field) => {
              const value = this.state.addData[field];
              this.state.addData[field] =
                value === 0 || value ? String(value) : "";
            });
            this.syncScoreFieldErrors();
            this.setState({});
          }
          dispatch({ type: "SHOW_LOADER", data: false });
        } else {
        }
      })
      .catch((error) => {
        if (error?.response?.status === 401) {
        }
      });
  };
  getShortSummaryDesc = (id, inspection) => {
    const { dispatch } = this.props;
    let apiUrl = `${API.Get_Richtext}?ShipId=${id}&InspectionId=${inspection}&SectionId=${inspectionSystem.SummaryShort}`;
    dispatch({ type: "SHOW_LOADER", data: true });
    axios
      .get(apiUrl)
      .then((response) => {
        if (response?.status === 200) {
          if (response.data.Id == 0) {
            $("#maxContentPost").text(2000 - 0);
          }
          if (response?.data.Description !== null && response?.data.Id !== 0) {
            this.state.addShortDescription = response?.data;
            this.setState({});
            // let result = atob(this.state.addShortDescription.Description);
            let result = htmlDecode(
              this.state.addShortDescription?.Description
            );
            this.setState({
              CancelSummary1: result,
            });
            this.props.dispatch({
              type: "RICHTEXT_CANCEL1",
              data: this.state.CancelSummary1,
            });
            window["getsummernote_code1"](result);
            setTimeout(() => {
              this.setState({ initialLoad: false });
            }, 600);
          } else {
            this.setState({ initialLoad: false });
          }
          dispatch({ type: "SHOW_LOADER", data: false });
        } else {
          this.setState({ initialLoad: false });
        }
      })
      .catch((error) => {
        this.setState({ initialLoad: false });
        if (error?.response?.status === 401) {
        }
      });
  };
  getDetailedSummaryDesc = (id, inspection) => {
    const { dispatch } = this.props;
    let apiUrl = `${API.Get_Richtext}?ShipId=${id}&InspectionId=${inspection}&SectionId=${inspectionSystem.SummaryDetailed}`;
    dispatch({ type: "SHOW_LOADER", data: true });
    axios
      .get(apiUrl)
      .then((response) => {
        if (response?.status === 200) {
          if (response?.data.Description !== null && response?.data.Id !== 0) {
            this.state.addDetailedDescription = response?.data;
            this.setState({});
            // let result = atob(this.state.addDetailedDescription.Description);
            let result = htmlDecode(
              this.state.addDetailedDescription?.Description
            );
            this.setState({
              CancelSummary: result,
            });
            this.props.dispatch({
              type: "RICHTEXT_CANCEL",
              data: this.state.CancelSummary,
            });
            window["getsummernote_code"](result);
          }
          dispatch({ type: "SHOW_LOADER", data: false });
        } else {
        }
      })
      .catch((error) => {
        if (error?.response?.status === 401) {
        }
      });
  };
  addShipSummaryInfo = (data) => {
    let apiUrl = API.AddEdit_Inspection;
    this.props.dispatch({ type: "SHOW_LOADER", data: true });
    axios({
      method: "POST",
      url: apiUrl,
      data: data,
    })
      .then((response) => {
        this.props.dispatch({ type: "SHOW_LOADER", data: false });
        if (response?.status === 200) {
          this.state.addData.Id = response?.data;
          this.setState({});
          //successAlert("Data saved successfully.");
          successToast();
        } else {
        }
      })
      .catch((error) => {
        this.props.dispatch({ type: "SHOW_LOADER", data: false });
        // warningAlert("Something went wrong. Please try again.");
        errorToast();
        this.props.dispatch({ type: "CANCEL", data: true });
        if (error?.response?.status === 401) {
        }
      });
  };

  addShortSummaryDesc = (data) => {
    let apiUrl = API.AddEdit_Richtext;
    this.props.dispatch({ type: "SHOW_LOADER", data: true });
    axios({
      method: "POST",
      url: apiUrl,
      data: data,
    })
      .then((response) => {
        this.props.dispatch({ type: "SHOW_LOADER", data: false });
        if (response?.status === 200) {
          this.state.addShortDescription.Id = response?.data;
          this.setState({});
          let SummeryResult1 = window["getsummernote_code1"]();
          this.state.CancelSummary1 = SummeryResult1;
          this.props.dispatch({
            type: "RICHTEXT_CANCEL1",
            data: SummeryResult1,
          });
        } else {
        }
        this.props.dispatch({ type: "SHOW_LOADER", data: false });
      })
      .catch((error) => {
        this.props.dispatch({ type: "SHOW_LOADER", data: false });
        // warningAlert("Something went wrong. Please try again.");
        errorToast();
        this.props.dispatch({ type: "CANCEL", data: true });
        if (error?.response?.status === 401) {
        }
      });
  };

  addDetailedSummaryDesc = (data) => {
    let apiUrl = API.AddEdit_Richtext;
    this.props.dispatch({ type: "SHOW_LOADER", data: true });
    axios({
      method: "POST",
      url: apiUrl,
      data: data,
    })
      .then((response) => {
        this.props.dispatch({ type: "SHOW_LOADER", data: false });
        if (response?.status === 200) {
          this.state.addDetailedDescription.Id = response.data;
          this.setState({});
          let SummeryResult = window["getsummernote_code"]();
          this.state.CancelSummary = SummeryResult;
          this.props.dispatch({ type: "RICHTEXT_CANCEL", data: SummeryResult });
          if (
            this.state.addData.Id !== 0 &&
            this.state.addShortDescription.Id !== 0 &&
            this.state.addDetailedDescription.Id !== 0
          ) {
            // this.props.navigate("/inspection/operationaldata")
          }
        } else {
        }
      })
      .catch((error) => {
        this.props.dispatch({ type: "SHOW_LOADER", data: false });
        // warningAlert("Something went wrong. Please try again.");
        errorToast();
        this.props.dispatch({ type: "CANCEL", data: true });
        if (error?.response?.status === 401) {
        }
      });
  };

  Save = () => {
    const { dispatch } = this.props;
    let ShortSummerResult = window["getsummernote_code1"]();
    let DetailedSummerResult = window["getsummernote_code"]();
    const { TotalGrade, Condition, Management } = this.state.addData;

    this.state.isError1 = !this.isValidScoreValue(TotalGrade);
    this.state.isError2 = !this.isValidScoreValue(Condition);
    this.state.isError3 = !this.isValidScoreValue(Management);
    this.setState({});

    if (this.state.isError1 || this.state.isError2 || this.state.isError3) {
      return;
    }

    this.state.addData.TotalGrade = parseInt(TotalGrade, 10);
    this.state.addData.Condition = parseInt(Condition, 10);
    this.state.addData.Management = parseInt(Management, 10);
    this.setState({});

    if (
      this.state.addData.TotalGrade !== "" &&
      this.state.addData.Condition !== "" &&
      this.state.addData.Management !== ""
    ) {
      if (this.state.addData.Id === 0) {
        this.state.addData.CreatedBy = localStorage.getItem("UserRoles");
        this.state.addData.Modifiedby = "";
        this.setState({});
        this.addShipSummaryInfo(this.state.addData);
        this.setState({ cancel: false });
        localStorage.setItem("EditID", this.state.addData.Id);
        this.props.dispatch({ type: "CANCEL", data: false });
      } else {
        this.state.addData.CreatedBy = "";
        this.state.addData.Modifiedby = localStorage.getItem("UserRoles");
        this.setState({});
        // dispatch(putShipSummaryInfo(this.state.addData, this.state.addData.Id));
        this.setState(
          {
            putData: true,
          },
          () => {
            console.log(this.state.putData);
          }
        );
        //PutShipSummaryInfo(this.state.addData, this.state.addData.Id);

        this.props.dispatch({ type: "CANCEL", data: false });
      }
      if (this.state.addShortDescription.Id === 0) {
        this.state.addShortDescription.CreatedBy =
          localStorage.getItem("UserRoles");
        this.state.addShortDescription.ModifiedBy = "";
        this.state.addShortDescription.Description =
          htmlEncode(ShortSummerResult);
        let ReportShortSummerResult = ReportDesc(ShortSummerResult);
        this.state.addShortDescription.ReportDescription = htmlEncode(
          ReportShortSummerResult
        );
        this.setState({});
        this.addShortSummaryDesc(this.state.addShortDescription);
        this.setState({ cancel: false });
        this.props.dispatch({ type: "CANCEL", data: false });
      } else {
        this.state.addShortDescription.CreatedBy = "";
        this.state.addShortDescription.ModifiedBy =
          localStorage.getItem("UserRoles");
        this.state.addShortDescription.Description =
          htmlEncode(ShortSummerResult);
        let ReportShortSummerResult = ReportDesc(ShortSummerResult);
        this.state.addShortDescription.ReportDescription = htmlEncode(
          ReportShortSummerResult
        );
        this.setState({});
        dispatch(
          putShortSummaryDesc(
            this.state.addShortDescription,
            this.state.addShortDescription.Id
          )
        );

        let SummeryResult1 = window["getsummernote_code1"]();
        this.state.CancelSummary = SummeryResult1;
        this.props.dispatch({ type: "RICHTEXT_CANCEL1", data: SummeryResult1 });
        this.props.dispatch({ type: "CANCEL", data: false });
      }
      // if (this.state.addDetailedDescription.Id === 0) {
      //   this.state.addDetailedDescription.CreatedBy = localStorage.getItem("UserRoles");
      //   this.state.addDetailedDescription.ModifiedBy = "";
      //   this.state.addDetailedDescription.Description = htmlEncode(DetailedSummerResult);
      //   let ReportDetailedSummerResult = ReportDesc(DetailedSummerResult);
      //   this.state.addDetailedDescription.ReportDescription = htmlEncode(ReportDetailedSummerResult);
      //   this.setState({})
      //   this.addDetailedSummaryDesc(this.state.addDetailedDescription);
      //   this.setState({ cancel: false })
      //   this.props.dispatch({ type: "CANCEL", data: false });
      // } else {
      //   this.state.addDetailedDescription.CreatedBy = "";
      //   this.state.addDetailedDescription.ModifiedBy = localStorage.getItem("UserRoles");
      //   this.state.addDetailedDescription.Description = htmlEncode(DetailedSummerResult);
      //   let ReportDetailedSummerResult = ReportDesc(DetailedSummerResult);
      //   this.state.addDetailedDescription.ReportDescription = htmlEncode(ReportDetailedSummerResult);
      //   this.setState({})
      //   dispatch(putDetailedSummaryDesc(this.state.addDetailedDescription, this.state.addDetailedDescription.Id));
      //   let SummeryResult = window["getsummernote_code"]();
      //   this.state.CancelSummary = SummeryResult;
      //   this.props.dispatch({ type: 'RICHTEXT_CANCEL', data: SummeryResult })
      //   this.props.dispatch({ type: "CANCEL", data: false });
      // }
    }
  };
  render() {
    let { classes, menuToggle } = this.props;
    const { isError1, isError2, isError3 } = this.state;

    return (
      <>
        <PutShipSummaryInfo
          data={this.state.addData}
          id={this.state.addData.Id}
          putData={this.state.putData}
        />
        {this.state.isMobile ? (
          <>
            <div className="row w-100 mt-4 mob-topfixed ">
              <div className="col-6 mt-auto">
                <List
                  className="pt-3 mt-4 pl-3"
                  style={{ backgroundColor: "#F6F6F6" }}
                >
                  <ListItem onClick={this.sidebar}>
                    <ListItemText
                      id={"ISUM" + "1"}
                      className="  textNaviIcon"
                      primary="Inspection Tasks"
                    />
                    <NavigateNextIcon
                      id="ISUM"
                      className="naviIcon ml-1"
                      style={{ width: 23, height: 23 }}
                    />
                    <Divider className="border-bottom" />
                  </ListItem>
                </List>
              </div>
              <div className="col-6 pt-2 mt-5 ">
                <h4>Inspection Summary</h4>
              </div>
            </div>
          </>
        ) : (
          <></>
        )}

        <div
          className="ml-auto scroll-hide mt-138"
          style={{
            backgroundColor: "#FFFFFF",
            width: this.state.isMobile
              ? "100%"
              : menuToggle
              ? "calc(100% - 240px)"
              : "calc(100% - 64px)",
            marginTop: this.state.isMobile ? "" : -75,
          }}
        >
          {this.state.isMobile ? (
            <table className="dataTable border-top" width="100%">
              <tbody>
                <tr>
                  <td className="border-right text-center">
                    <i
                      class="fa fa-arrow-left cursorPointer"
                      onClick={this.AddCancel1}
                    ></i>
                  </td>
                  <td className="border-right text-center">
                    <button
                      className={`${classes.button}`}
                      onClick={() => {
                        this.Save();
                      }}
                    >
                      <img src={Save} style={{ marginTop: "-4px" }}></img>
                      &nbsp;Save
                    </button>
                  </td>
                  <td className="text-center">
                    <button
                      className={`${classes.button} `}
                      onClick={this.AddCancel1}
                    >
                      <img src={Cancel} style={{ marginTop: "-4px" }}></img>
                      &nbsp;Cancel
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          ) : (
            <>
              <table className="dataTable" width="100%">
                <tbody>
                  <tr>
                    <td width="5%" className="border-right text-center">
                      <i
                        class="fa fa-arrow-left cursorPointer"
                        onClick={this.AddCancel1}
                      ></i>
                    </td>
                    <td className="" width="95%">
                      <button
                        className={`${classes.button}`}
                        onClick={() => this.Save()}
                      >
                        <img src={Save} style={{ marginTop: "-4px" }}></img>
                        &nbsp;Save
                      </button>
                      <button
                        className={`${classes.button} pl-3`}
                        onClick={this.AddCancel1}
                      >
                        <img src={Cancel} style={{ marginTop: "-4px" }}></img>
                        &nbsp;Cancel
                      </button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </>
          )}
          <div style={{ margin: this.state.isMobile ? "auto" : "5px" }}>
            {this.state.isMobile ? (
              ""
            ) : (
              <h6 className="col-12 mx-2 mt-3 ml-1">Inspection Summary</h6>
            )}
            <div
              className={
                this.state.isMobile
                  ? "row mt-1 mx-0 pr-2 pt-1"
                  : "row mt-1 mx-3 pr-2 pt-1"
              }
            >
              <div
                className={`row mt-2 mx-1 mb-3 align-items-center p-0 ${
                  this.state.isMobile ? "" : " "
                }`}
              >
                <div
                  className={`table-responsive" ${
                    this.state.isMobile ? "" : "p-0"
                  }`}
                  style={{ width: "100%" }}
                >
                  <table
                    id="Docstable"
                    className="table table-borderless border-top border-bottom border-left border-right"
                  >
                    <thead>
                      <tr className="border-top section-color spandoc-thead">
                        <th className="border-right border-left" colSpan="6">
                          <span className="spandoc-thead">
                            Vessel Grading Criteria
                          </span>
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr className="border-top border-color">
                        <td
                          width="50%"
                          className="border-right text-center align-middle section-color5"
                        >
                          <span className="spandoc-td spandoc-td1">
                            More than 90 %{" "}
                          </span>
                        </td>
                        <td
                          width="50%"
                          className="border-right text-center align-middle section-color1"
                        >
                          <span className="spandoc-td spandoc-td1">
                            Excellent
                          </span>
                        </td>
                      </tr>
                      <tr className="border-top border-color">
                        <td
                          width="50%"
                          className="border-right text-center align-middle section-color5"
                        >
                          <span className="spandoc-td spandoc-td1">
                            80 % – 90 %{" "}
                          </span>
                        </td>
                        <td
                          width="50%"
                          className="border-right text-center align-middle section-color2"
                        >
                          <span className="spandoc-td spandoc-td1">Good </span>
                        </td>
                      </tr>
                      <tr className="border-top border-color">
                        <td
                          width="50%"
                          className="border-right text-center align-middle section-color5"
                        >
                          <span className="spandoc-td spandoc-td1">
                            60 % – 80 %{" "}
                          </span>
                        </td>
                        <td
                          width="50%"
                          className="border-right text-center align-middle section-color3"
                        >
                          <span className="spandoc-td spandoc-td1">Fair</span>
                        </td>
                      </tr>
                      <tr className="border-top border-color">
                        <td
                          width="50%"
                          className="border-right text-center align-middle section-color5"
                        >
                          <span className="spandoc-td spandoc-td1">
                            Less than 60 %{" "}
                          </span>
                        </td>
                        <td
                          width="50%"
                          className="border-right text-center align-middle section-color4"
                        >
                          <span className="spandoc-td spandoc-td1">Poor</span>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
              <div
                className={`row mx-1 mb-2 align-items-center ${
                  this.state.isMobile ? "" : "text-row desc-score-row"
                }`}
              >
                {this.renderScoreFieldGroup("TotalGrade", "TotalGrade", isError1)}
                {this.renderScoreFieldGroup("Condition", "Condition", isError2)}
                {this.renderScoreFieldGroup("Management", "Management", isError3)}
              </div>
              <div
                className={`row mx-1 mb-2 pt-2 p-0 ${
                  this.state.isMobile ? "" : " "
                }`}
              >
                <h6
                  className={`col-12 mt-3 ${this.state.isMobile ? "" : "p-0"}`}
                >
                  Inspection Summary
                </h6>
                <div
                  className={
                    this.state.isMobile
                      ? "col-12 pt-2 mt-1"
                      : "col-12 p-0 pt-2 mt-1"
                  }
                >
                  <div className="pt-2" id="summernote1"></div>
                </div>
                {/* <div class="col-12 text-right">
                  <span id="maxContentPost"></span><span> Characters left</span>
                </div> */}
              </div>
              {/* <div className={`row mx-1 pt-2 mb-2 p-0 ${this.state.isMobile ? "" : " "}`}>
                <h6 className={`col-12 mt-3 ${this.state.isMobile ? "" : "p-0"}`}> Summary - Detailed</h6>
                <div className={this.state.isMobile ? "col-12 pt-2 mt-1" : "col-12 p-0 pt-2 mt-1"}>
                  <div className="" id="summernote"></div>
                </div>
              </div> */}
            </div>
            <div
              className="modal fade p-5 mt-5"
              id="cancelpopup"
              tabindex="-1"
              role="dialog"
              aria-labelledby="cancelpopupLabel"
              aria-hidden="true"
              style={{
                top: "13%",
                left: this.state.isMobile ? "2%" : menuToggle ? "10%" : "",
              }}
            >
              <div className="modal-dialog" role="document">
                <div
                  className={
                    this.state.isMobile ? "modal-content" : "modal-content p-3"
                  }
                >
                  <div className="modal-body pb-0">
                    <h1 className="text-center">
                      <img src={del}></img>
                    </h1>
                    <div className="text-center">
                      <h5 className="fw-bold">
                        Changes are not saved yet. The data will be lost. Do you
                        really want to cancel?
                      </h5>{" "}
                    </div>
                  </div>
                  <div className="modal-footer border-top-0 m-auto">
                    <button
                      type="button"
                      className={
                        this.state.isMobile
                          ? "btn btn-secondary"
                          : " btn btn-secondary py-2 px-4"
                      }
                      data-dismiss="modal"
                      style={{ backgroundColor: "#499AC8", border: "none" }}
                      onClick={this.AddCancel}
                    >
                      <span className="">Yes</span>
                    </button>
                    <button
                      type="button"
                      id="closemodal1"
                      className={
                        this.state.isMobile
                          ? "btn btn-secondary"
                          : " btn btn-secondary py-2 px-4"
                      }
                      onClick={() => window.$("#cancelpopup").modal("hide")}
                      style={{
                        backgroundColor: "#EBEBEB",
                        border: "none",
                        color: "#111010",
                      }}
                    >
                      <span className="">No</span>
                    </button>
                  </div>
                </div>
              </div>
            </div>

            <div
              class="modal fade p-5 mt-5"
              id="cancelpopup1"
              tabindex="-1"
              role="dialog"
              aria-labelledby="cancelpopupLabel"
              aria-hidden="true"
              style={{
                top: "13%",
                left: this.state.isMobile ? "2%" : menuToggle ? "10%" : "",
              }}
            >
              <div class="modal-dialog" role="document">
                <div
                  class={
                    this.state.isMobile ? "modal-content" : "modal-content p-3"
                  }
                >
                  <div class="modal-body pb-0">
                    <h1 className="text-center">
                      <img src={del}></img>
                    </h1>
                    <div className="text-center">
                      <h5 class="fw-bold">
                        Changes are not saved yet. The data will be lost. Do you
                        really want to cancel?
                      </h5>{" "}
                    </div>
                  </div>
                  <div class="modal-footer border-top-0 m-auto">
                    <button
                      type="button"
                      class={
                        this.state.isMobile
                          ? "btn btn-secondary"
                          : " btn btn-secondary py-2 px-4"
                      }
                      data-dismiss="modal"
                      style={{ backgroundColor: "#499AC8", border: "none" }}
                      onClick={this.SideBarCancel}
                    >
                      <span className="">Yes</span>
                    </button>
                    <button
                      type="button"
                      id="closemodal1"
                      class={
                        this.state.isMobile
                          ? "btn btn-secondary"
                          : " btn btn-secondary py-2 px-4"
                      }
                      onClick={() => window.$("#cancelpopup1").modal("hide")}
                      style={{
                        backgroundColor: "#EBEBEB",
                        border: "none",
                        color: "#111010",
                      }}
                    >
                      <span className="">No</span>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}
function mapDispatchToProps(dispatch) {
  return {
    dispatch,
  };
}

function mapStateToProps(state) {
  return {
    menuToggle: state.commonReducer.menuToggle,
    settings: state.commonReducer.settings || [],
  };
}

AddEditDESC.propTypes = {
  classes: PropTypes.object.isRequired,
};
export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(AddEditDESC))
);
